import { Component, OnInit } from '@angular/core';
import { LoginDataService } from "app/login/login-data.service";
import { HeaderService } from "app/header/header.service";
import { UserResource } from "app/resources/user/user-resource";
import { Router } from "@angular/router";
import { trigger, state, style, animate, transition } from '@angular/animations';
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "app/message-service.service";
import { Subscription } from "rxjs";
import { UtilsService } from 'app/services/utils.service';

@Component({
	selector: 'vbn-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	providers: [HeaderService],
	animations: [
		trigger('profileDropDown', [
			state('inactive', style({
				display: "none",
				opacity: '0',
				transform: 'translateY(-10px)'
			})),
			state('active', style({
				display: "block",
				opacity: '1',
				transform: 'translateY(0px)'
			})),
			transition('inactive => active', animate('100ms ease-in')),
			transition('active => inactive', animate('100ms ease-out'))
		]),
	]
})
export class HeaderComponent implements OnInit {
	
	loggedUser: string = localStorage.getItem('_user');
	errorMessage: string;
	userResource: UserResource;
	show: boolean = false;
	profile: boolean = false;
	language = localStorage.getItem("vbn-language");
	state: string = "inactive"
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	subscription: Subscription;
	showProfileDropdown: boolean = false;

	toogleAnimProfileDropDown() {
		if(this.state === "active") {
			this.state = "inactive"
		} else {
			this.state = "active"
		}
	}	

	constructor(
		private _login: LoginDataService, 
		private headerService: HeaderService, 
		private router: Router, 
		private translate: TranslateService,
		private messageService: MessageService,
		private service: UtilsService) {
		this.userResource = new UserResource();
		this.subscription = this.messageService.getMessage().subscribe(message => {
			this.userResource = message.content; 
		});
	}
	// setLanguage(newLang){
	// 	localStorage.setItem("vbn-language", newLang)
	// 	this.translate.setDefaultLang(newLang)
	// 	this.translate.use(newLang)
	// 	this.language = localStorage.getItem("vbn-language");
	// }
 	langToEn() {
		localStorage.setItem("vbn-language", 'en')
		this.translate.setDefaultLang('en')
		this.translate.use('en')
		this.language = localStorage.getItem("vbn-language");
	} 

	langToFr() {
		localStorage.setItem("vbn-language", 'fr')
		this.translate.setDefaultLang('fr')
		this.translate.use('fr')
		this.language = localStorage.getItem("vbn-language");
	}
 
	langToRo() {
		localStorage.setItem("vbn-language", 'ro')
		this.translate.setDefaultLang('ro')
		this.translate.use('ro')
		this.language = localStorage.getItem("vbn-language");
	} 

	langToDe() {
		localStorage.setItem("vbn-language", 'de')
		this.translate.setDefaultLang('de')
		this.translate.use('de')
		this.language = localStorage.getItem("vbn-language");
	}

	ngOnInit() {
		console.log("logg", atob(this.loggedUser))
		this.service.currentUserEmail = (atob(localStorage.getItem("_sc")) === atob(null)) ? atob(this.loggedUser) : atob(localStorage.getItem("_sc"));
		this.getUserProfile(this.loggedUser)
		if(localStorage.getItem("_sc") && this.router.url != "/home") {
			let currentClient = localStorage.getItem("_sc");
			this.getCurrentClientSelected(currentClient);
		}
	}

	disablelogin() {
		this._login.logOut()
	}

	getUserProfile(email: string) {
		this.headerService.getUserProfile(email)
			.subscribe(
			response => {
				this.userResource = response;
			},
			error => this.errorMessage = <any>error);
	}

	getCurrentClientSelected(email: string) {
		this.headerService.getUserProfile(email)
			.subscribe(
			response => {
				this.service.changeAppModuleEnable(response.canUseAppointments);
			},
			error => this.errorMessage = <any>error);
	}

	// showMyProfile() {
	// 	this.show = true;
	// }

	goToMyProfile(item) {
		this.show = false;
		this.router.navigate(['/my-profile']);
	}

	hideProfileDropdown(){
		this.showProfileDropdown = false;
	}

	showProfileDrop(){
		this.showProfileDropdown = true;
	}

}
